<template lang="html">
  <div class="manager">
    <div
      v-if="error"
      class="alert alert-danger text-center"
      role="alert">
      {{ error.message }}
    </div>
    <div
      v-if="success"
      class="alert alert-success text-center"
      role="alert">
      {{ successMessage }}
    </div>
    <div class="card">
      <div class="card-header">
        <h3>Gerenciar Integrações</h3>
      </div>
      <div class="card-body">
        <h3 class="card-title">Api4Com</h3>
        <div class="row">
          <div class="col-4">
            <integration-sippulse @onError="onError" />
          </div>
          <div class="col-4">
            <integration-webhook @onError="onError" />
          </div>
          <div
            v-if="isAdmin"
            class="col-4">
            <copy-recordings
              v-if="isRolloutCopyRecordings"
              @onError="onError" />
          </div>
        </div>
        <h3 class="card-title">CRM's</h3>
        <div class="dataTables_wrapper">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div class="collapse d-md-block">
                <div class="d-block d-md-inline-block">
                  <div class="btn-group float-md-left mr-1 mb-1">
                    <button
                      class="btn btn-outline-dark btn-xs dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false">
                      Ordenar
                      <i class="ik ik-chevron-down mr-0 align-middle" />
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        :class="{
                          'bg-inverse': order === 'asc',
                          'text-white': order === 'asc'
                        }"
                        href="#"
                        @click.prevent="sortUserIntegrations('asc')">Crescente</a>
                      <a
                        class="dropdown-item"
                        :class="{
                          'bg-inverse': order === 'desc',
                          'text-white': order === 'desc'
                        }"
                        href="#"
                        @click.prevent="sortUserIntegrations('desc')">Decrescente</a>
                    </div>
                  </div>
                  <div class="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                    <div class="input-group input-group-button">
                      <div class="input-group-prepend">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Pesquisar..."
                          v-model="search"
                          @keyup="searchUserIntegrations">
                        <div class="input-group-append">
                          <button
                            class="btn btn-outline-dark"
                            type="button"
                            @click.prevent="clearSearchUserIntegrations">Limpar</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="user-integrations">
          <div
            class="integration-item activecampaign col-4"
            v-if="isRolloutActiveCampaign">
            <integration-active-campaign @onError="onError" />
          </div>
          <div class="integration-item agendor col-4">
            <integration-agendor @onError="onError" />
          </div>
          <div class="integration-item appfacilita col-4">
            <integration-app-facilita @onError="onError" />
          </div>
          <div class="integration-item exactsales col-4">
            <integration-exact-sales @onError="onError" />
          </div>
          <div class="integration-item groner col-4">
            <integration-groner @onError="onError" />
          </div>
          <div class="integration-item hubspot col-4">
            <integration-hubspot @onError="onError" />
          </div>
          <div class="integration-item kommo col-4">
            <integration-kommo @onError="onError" />
          </div>
          <div class="integration-item moskit col-4">
            <integration-moskit @onError="onError" />
          </div>
          <div class="integration-item nectar col-4">
            <integration-nectar @onError="onError" />
          </div>
          <div class="integration-item pipedrive col-4">
            <integration-pipedrive
              @onError="onError"
              :is-rollout-a-i="isRolloutAI" />
          </div>
          <div class="integration-item pipefy col-4">
            <integration-pipefy @onError="onError" />
          </div>
          <div class="integration-item piperun col-4">
            <integration-piperun @onError="onError" />
          </div>
          <div class="integration-item ploomes col-4">
            <integration-ploomes @onError="onError" />
          </div>
          <div class="integration-item rdstation col-4">
            <integration-rdstation-crm @onError="onError" />
          </div>
          <div class="integration-item salesflow col-4">
            <integration-salesflow-crm @onError="onError" />
          </div>
          <div class="integration-item salesforce col-4">
            <integration-salesforce @onError="onError" />
          </div>
          <div class="integration-item sharpspring col-4">
            <integration-sharpspring @onError="onError" />
          </div>
          <div class="integration-item zendesk col-4">
            <integration-zendesk @onError="onError" />
          </div>
          <div class="integration-item zoho col-4">
            <integration-zoho @onError="onError" />
          </div>
          <div class="integration-item suggestions col-4">
            <div class="widget">
              <div class="widget-body">
                <a
                  title="Sugerir Integrações"
                  class="link"
                  href="https://forms.gle/81oDtrCU4gjAvTWA9"
                  target="_blank">
                  <h1>Solicite novas Integrações</h1>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import IntegrationActiveCampaign from './ActiveCampaign'
import IntegrationAgendor from './Agendor'
import IntegrationAppFacilita from './AppFacilita'
import IntegrationExactSales from './ExactSales'
import IntegrationGroner from './Groner'
import IntegrationHubspot from './HubSpot'
import IntegrationKommo from './Kommo'
import IntegrationMoskit from './Moskit'
import IntegrationNectar from './Nectar'
import IntegrationPipedrive from './Pipedrive'
import IntegrationPipefy from './Pipefy'
import IntegrationPiperun from './Piperun'
import IntegrationPloomes from './Ploomes'
import IntegrationRdstationCrm from './RdstationCrm'
import IntegrationSalesflowCrm from './SalesflowCrm'
import IntegrationSalesforce from './Salesforce'
import IntegrationSharpspring from './Sharpspring'
import IntegrationSippulse from './Sippulse'
import IntegrationZendesk from './Zendesk'
import IntegrationWebhook from './Webhook'
import CopyRecordings from './CopyRecordings'
import IntegrationZoho from './ZohoCrm'

const USER_INTEGRATIONS = {
  activecampaign: 'ActiveCampaign CRM',
  agendor: 'Agendor CRM',
  appfacilita: 'AppFacilita CRM',
  exactsales: 'Exact Sales CRM',
  groner: 'Groner',
  hubspot: 'Hubspot CRM',
  kommo: 'Kommo',
  moskit: 'Moskit CRM',
  nectar: 'Nectar CRM',
  pipedrive: 'Pipedrive CRM',
  pipefy: 'Pipefy CRM',
  piperun: 'Piperun CRM',
  ploomes: 'Ploomes CRM',
  rdstation: 'RDStation CRM',
  salesflow: 'SalesFlow CRM',
  salesforce: 'Salesforce CRM',
  sharpspring: 'SharpSpring CRM',
  zendesk: 'Zendesk',
  zoho: 'Zoho CRM'
}

export default {
  name: 'IntegrationManager',
  components: {
    IntegrationActiveCampaign,
    IntegrationAgendor,
    IntegrationAppFacilita,
    IntegrationExactSales,
    IntegrationGroner,
    IntegrationHubspot,
    IntegrationKommo,
    IntegrationMoskit,
    IntegrationNectar,
    IntegrationPipedrive,
    IntegrationPipefy,
    IntegrationPiperun,
    IntegrationPloomes,
    IntegrationRdstationCrm,
    IntegrationSalesflowCrm,
    IntegrationSalesforce,
    IntegrationSharpspring,
    IntegrationSippulse,
    IntegrationZendesk,
    IntegrationWebhook,
    CopyRecordings,
    IntegrationZoho
  },
  data () {
    return {
      error: null,
      isRolloutCopyRecordings: false,
      isRolloutActiveCampaign: false,
      isRolloutAI: false,
      search: '',
      order: 'asc',
      integrationSuccess: this.$route.query.success,
      integrationError: this.$route.query.error
    }
  },
  beforeMount () {
    this.loadRolloutAI()
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegrationError()
      this.loadRolloutRecordingsCloud()
      this.loadRolloutActiveCampaign()
    })
  },
  methods: {
    onError (err) {
      this.error = err
    },
    loadRolloutRecordingsCloud () {
      loopback
        .get('/rollout?featureFlag=copy-recordings')
        .then(rollout => {
          this.isRolloutCopyRecordings = rollout === 'ALLOWED'
        })
    },
    loadRolloutActiveCampaign () {
      loopback
        .get('/rollout?featureFlag=activecampaign-integration')
        .then(rollout => {
          this.isRolloutActiveCampaign = rollout === 'ALLOWED'
        })
    },
    loadRolloutAI () {
      loopback
        .get('/rollout?featureFlag=ai-integration')
        .then(rollout => {
          this.isRolloutAI = rollout === 'ALLOWED'
        })
    },
    sortUserIntegrations (order) {
      this.order = order
      Object.keys(USER_INTEGRATIONS).sort((a, b) => {
        if (order === 'asc') {
          return a.localeCompare(b)
        }
        return b.localeCompare(a)
      }).forEach((integration, index) => {
        const el = document.querySelector(`.${integration}`)
        if (el) {
          el.style.order = index
        }
        const suggestionEl = document.querySelector('.suggestions')
        if (suggestionEl) {
          suggestionEl.style.order = Object.keys(USER_INTEGRATIONS).length
        }
      })
    },
    searchUserIntegrations () {
      const userIntegrationsKeys = Object.keys(USER_INTEGRATIONS)
      Object.values(USER_INTEGRATIONS).forEach((integration, index) => {
        const el = document.querySelector(`.${userIntegrationsKeys[index]}`)
        if (el) {
          if (integration.match(new RegExp(this.search.toLowerCase(), 'i'))) {
            el.style.display = 'inline-block'
          } else {
            el.style.display = 'none'
          }
        }
      })
    },
    clearSearchUserIntegrations () {
      Object.keys(USER_INTEGRATIONS).forEach(integration => {
        const el = document.querySelector(`.${integration}`)
        if (el) {
          el.style.display = 'inline-block'
        }
      })
      this.search = ''
    },
    loadIntegrationError () {
      if (this.integrationError) {
        const errorMessage = `Não foi possível realizar a integração com ${USER_INTEGRATIONS[this.integrationError]}. Por favor, tente novamente.`
        this.error = {
          message: errorMessage
        }
      }
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    },
    success () {
      return this.integrationSuccess && this.integrationSuccess.length > 0
    },
    successMessage () {
      return `Integração com ${USER_INTEGRATIONS[this.integrationSuccess]} realizada com sucesso.`
    }
  }
}
</script>

<style lang="scss" scoped>
.embed-responsive {
  max-width: 800px;
  max-height: 600px;
  margin: auto;
}
.widget .widget-body {
  height: 144px !important;
  text-align: center;
}
/deep/ .link {
  color: blue !important;
  cursor: pointer;
  font-weight: bold;
}
/deep/ .state > h4 > small {
  font-size: 60%;
}

.user-integrations {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.integration-item {
  display: inline-block;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Integration/Manager.vue